/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_DTOs_UpdateUserNotificationPreferenceDTO } from '../models/Routemize_DTOs_UpdateUserNotificationPreferenceDTO';
import type { Routemize_DTOs_UserNotificationPreferenceDTO } from '../models/Routemize_DTOs_UserNotificationPreferenceDTO';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserNotificationPreferencesService {
    /**
     * @returns Routemize_DTOs_UserNotificationPreferenceDTO OK
     * @throws ApiError
     */
    public static getApiAppUserNotificationPreferencesGetMine(): CancelablePromise<Array<Routemize_DTOs_UserNotificationPreferenceDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/userNotificationPreferences/getMine',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_UserNotificationPreferenceDTO OK
     * @throws ApiError
     */
    public static postApiAppUserNotificationPreferencesUpsertMine(
        requestBody?: Routemize_DTOs_UpdateUserNotificationPreferenceDTO,
    ): CancelablePromise<Routemize_DTOs_UserNotificationPreferenceDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/userNotificationPreferences/upsertMine',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
